import { __INTERNAL_RELAY_ENVIRONMENT__DO_NOT_USE_THIS_DIRECTLY__ } from '@atlassian/relay-environment-provider/environment';
import RelayModernEnvironment from 'relay-runtime/lib/store/RelayModernEnvironment';

import { createRelayResource } from '@townsquare/relay-utils';
import type { ResourceContext } from '@townsquare/router/types';
import { fg } from '@townsquare/stat-sig/gate';

import ProjectSidebarAggQuery, {
	type ProjectSidebarAggQuery as ProjectSidebarAggQueryType,
} from '../components/ProjectSidebar/agg/__generated__/ProjectSidebarAggQuery.graphql';

export const projectSidebarAggResource = createRelayResource<ProjectSidebarAggQueryType>({
	getQuery: (routerContext, resourceContext) => {
		const containerId = (resourceContext as ResourceContext).collabContext?.contextId ?? '';
		const key = routerContext.match.params.id ?? '';
		const isCombinedAggQueryEnabled = fg('townsquare_enable_combined_agg_query_sidebar');
		const isEditPermsEnabled = fg('townsquare_edit_permissions_m1');

		return {
			query: ProjectSidebarAggQuery,
			environment: __INTERNAL_RELAY_ENVIRONMENT__DO_NOT_USE_THIS_DIRECTLY__ as RelayModernEnvironment,
			variables: {
				searchQuery: `key = ${key}`,
				containerId,
				isCombinedAggQueryEnabled,
				isEditPermsEnabled,
			},
		};
	},
});
